import { render, staticRenderFns } from "./BannerPerguntasFrequentes.vue?vue&type=template&id=f72e1c14&"
import script from "./BannerPerguntasFrequentes.vue?vue&type=script&lang=js&"
export * from "./BannerPerguntasFrequentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports